import { Suspense } from 'react'

import Loading from '@/components/shared/Loading'
import type { CommonProps } from '@/@types/common'
import type { LayoutType } from '@/@types/theme'

import CollapsibleSide from './CollapsibleSide'

interface PostLoginLayoutProps extends CommonProps {
    layoutType: LayoutType
}

const PostLoginLayout = ({ children }: PostLoginLayoutProps) => {
    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    <Loading loading={true} />
                </div>
            }
        >
            <CollapsibleSide>{children}</CollapsibleSide>
        </Suspense>
    )
}

export default PostLoginLayout
